import { createStore as _createStore } from 'vuex'
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export function createStore () {
  return _createStore({
    state: {
        trainings: null,
        trainingSessions: {},
        latestQuizResponses: null,
        latestEvaluationResponses: {},
        isQuizLoading: true,
        currentTrainingId: -1,
        showAddTrainingSession: false,
        currentTrainingSession: {},
        currentContentComponent: {},
        showContent: false,
    },
    actions,
    getters,
    mutations
  })
}